import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { TagsManagerDataProviderFactory } from '../factory/TagsManagerDataProviderFactory';
import { TagsManagerBaseDataProvider } from '../dataProvider/TagsManagerBaseDataProvider';
import { CreateRequestPayload } from '../../../utils/request';

export class TagsManagerRepository extends BaseWebComponentRepository {
  public dataProviderFactory: TagsManagerDataProviderFactory;
  public dataProvider: TagsManagerBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new TagsManagerDataProviderFactory(),
    });
  }

  public async removeGzTagRecords(payload: CreateRequestPayload['payload'], allSelected: boolean): Promise<object> {
    return this.dataProvider.removeGzTagRecords(payload, allSelected);
  }
}
